import React, { Component, Fragment } from 'react';
import OptionsMenu from './OptionsMenu';
import Help from './Help.js';
import PrintSelector from './PrintSelector';
import PrintMessage from './PrintMessage';
import { openSummary, openPrintSelector, closeOptionsMenu, closePrintWarning } from '../lib/functions.js';

class ModalPrint extends Component {

    constructor() {
        super();
        this.state = {
            showModal: true,
            qchecked: false,
            mschecked: false,
            erchecked: false,
            nchecked: false,
            allQuestions: [],
            allMarks: [],
            allExaminer: [],
            allNotes: [],
            printID: "dont-print",
        }
    }

    componentDidMount() {
        if (typeof (Storage) !== "undefined") {
            let temp = localStorage.getItem("showModal")
            if (temp === "no") {
                this.setState({ showModal: false })
            }
        } else {
            console.log("no storage")
        }
    }

    summaryPrint = () => {
      openSummary()
      this.setState({
        printID: "dont-print"
      })
      closeOptionsMenu()
    }

  mainPrintSelection = () => {
    openPrintSelector()
    this.setState({
      printID: "print-this"
    })
    closeOptionsMenu()
  }

  handlePrintChange = (e) => {
    let contentPrint = e.target.name;
    let questions = [];
    let marks = [];
    let examiner = [];
    let notes = [];
    let print;

    switch(contentPrint) {
        case "question":
          print = this.state.qchecked === true ? null : "Q";
          questions.push(print)
          closePrintWarning();
          break;

        case "markscheme":
          print = this.state.mschecked === true ? null : "M";
          marks.push(print);
          closePrintWarning();
          break;

        case "examinerreport":
          print = this.state.erchecked === true ? null : "E";
          examiner.push(print)
          closePrintWarning();
          break;

        case "notes":
          print = this.state.nchecked === true ? null : "N";
          notes.push(print)
          closePrintWarning();
          break;

        default:
          print = "";
      }

      switch (contentPrint) {
          case "question":
              this.setState(prevState => ({
                  qchecked: !prevState.qchecked,
                  allQuestions: questions
              }))
              break;
          case "markscheme":
              this.setState(prevState => ({
                  mschecked: !prevState.mschecked,
                  allMarks: marks
              }))
              break;

          case "examinerreport":
              this.setState(prevState => ({
                  erchecked: !prevState.erchecked,
                  allExaminer: examiner
              }))
              break;

          case "notes":
              this.setState(prevState => ({
                  nchecked: !prevState.nchecked,
                  allNotes: notes
              }))
              break;

          default:
              console.log("Nothing Selected");
      }

  }


    closeModal = () => {
        this.setState({ showModal: false })
        let check = document.getElementById("dontShowAgain").checked;
        if (check === true) {
            this.handleLocalStorage();
        } else {
            this.showModal();
        }
    }

    handleLocalStorage = () => {
        if (typeof (Storage) !== "undefined") {
            localStorage.setItem("showModal", "no")
        } else {
            console.log("no storage")
        }
    }

    showModal = () => {
        if (typeof (Storage) !== "undefined") {
            localStorage.setItem("showModal", "yes")
        } else {
            console.log("no storage")
        }
    }

    handleHelpMenu = () => {
        this.setState({ showModal: true })
    }
    render() {
        return (
            <Fragment>
                <Help brand={this.props.brand}
                    show={this.state.showModal}
                    closeModal={this.closeModal}
                    handleLocalStorage={this.handleLocalStorage}
                >
                </Help>
                <OptionsMenu
                    summaryPrint={this.summaryPrint}
                    handleHelpMenu={this.handleHelpMenu}
                    printSelector={this.mainPrintSelection} />
                <PrintSelector
                    showq={this.props.showq}
                    showm={this.props.showm}
                    showe={this.props.showe}
                    shown={this.props.shown}
                    printID={this.state.printID}
                    handlePrintChange={this.handlePrintChange}
                    qchecked={this.state.qchecked}
                    mschecked={this.state.mschecked}
                    erchecked={this.state.erchecked}
                    nchecked={this.state.nchecked}
                    allQuestions={this.state.allQuestions}
                    allMarks={this.state.allMarks}
                    allExaminer={this.state.allExaminer}
                    allNotes={this.state.allNotes}
                    docID={this.props.docID} />
                <PrintMessage brand={this.props.brand} />
            </Fragment>
        );
    }
}

export default ModalPrint;